/// <reference types="vite/client" />

/**
 * Environment Configuration
 *
 * Centralized access to all VITE_* environment variables with
 * appropriate defaults for development and production.
 */

/**
 * Whether the app is running in production mode.
 * Vite sets `import.meta.env.PROD` to `true` during `vite build`.
 */
export const IS_PRODUCTION = import.meta.env.PROD === true;

/**
 * Whether the app is running in development mode.
 * Vite sets `import.meta.env.DEV` to `true` during `vite dev`.
 */
export const IS_DEVELOPMENT = import.meta.env.DEV === true;

/**
 * The API base URL used for all backend requests.
 *
 * Priority:
 *   1. VITE_API_BASE_URL environment variable (if set)
 *   2. Production default if built for production
 *   3. Local development default otherwise
 */
export const API_BASE_URL: string =
  import.meta.env.VITE_API_BASE_URL ||
  (IS_PRODUCTION
    ? 'https://api.mellify.ai/api/v1'
    : 'http://localhost:3001/api/v1');

/**
 * Google OAuth Client ID (for Google Sign-In button on frontend).
 */
export const GOOGLE_CLIENT_ID: string =
  import.meta.env.VITE_GOOGLE_CLIENT_ID || '';

/**
 * Stripe publishable key (for client-side Stripe integration).
 */
export const STRIPE_PUBLISHABLE_KEY: string =
  import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '';

/**
 * Current app environment label.
 */
export const APP_ENV: string =
  import.meta.env.VITE_APP_ENV || (IS_PRODUCTION ? 'production' : 'development');